import { z } from "zod";
//#region src/upgrade-window.schemas.ts
/** Zod schema for the maintenance upgrade window (CP API). */
const UpgradeWindowSchema = z.object({
	dayOfWeek: z.array(z.number().int().min(0).max(6)).optional(),
	startHourUtc: z.number().int().min(0).max(23),
	endHourUtc: z.number().int().min(0).max(23)
}).strict();
//#endregion
export { UpgradeWindowSchema };

//# sourceMappingURL=upgrade-window.schemas.js.map